import styled, { css } from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
export const ParagraphRoot = styled.div `
  ${({ align, theme, variant: appVariant }) => {
    const variant = theme.typography.paragraph[appVariant];
    return css `
      color: ${theme.palette.text.primary};
      font-family: ${theme.typography.fontFamily};
      font-size: ${variant.fontSize};
      font-weight: ${theme.typography.fontWeight};
      line-height: calc(${variant.fontSize} * ${variant.lineHeight});
      text-align: ${align};
    `;
}}
`;
//# sourceMappingURL=Paragraph.styled.js.map